import { tableModule } from '@/store/table/module'
import type { TTableState } from '@/store/table/types'

const saveTableState = (tableState: TTableState) => {
    tableModule.state[tableState.name] = tableState
}

const resetTableState = (tableName: string) => {
    delete tableModule.state[tableName]
}

export default {
    saveTableState,
    resetTableState,
}
